// Modified publish-manager.js for integration with publishTextChange patch

import {isAuthenticated} from '../../auth';
import {showErrorNotification, showSuccessNotification} from '../../../utils/notifications';
import {config} from '../../../config/app-config';
import {publishTextChange as originalPublishTextChange} from '../text-editor';
import {publishImageChange, saveImageChangeLocal} from '../image-editor';
import {clearPendingChanges, getPendingChanges, hasPendingChanges} from '../content-store';
import {clearContentCache} from './content-loader';
import {eventHandlers} from './element-setup';
import {createPublishButton} from '../ui-elements';
import {publishYoutubeChange} from '../youtube-editor';
import {publishDocumentChange, saveDocumentChangeLocal} from '../document-editor';
import {publishBlockChanges} from '../../block-system/block-manager/block-publisher';
import {hasChanges as hasBlockChanges} from '../../block-system/block-manager/block-state';


export function addPublishButton() {
    const existingBtn = document.getElementById(config.editor.selectors.publishButton);
    if (existingBtn) {
        existingBtn.remove();
    }

    const publishBtn = createPublishButton();
    document.body.appendChild(publishBtn);

    const handlePublishClick = () => {
        publishChanges();
    };

    publishBtn.addEventListener('click', handlePublishClick);
    eventHandlers.add({element: publishBtn, type: 'click', handler: handlePublishClick});

    const handlePendingChanges = (event) => {
        const hasAny = event.detail.hasPending || hasBlockChanges();
        publishBtn.style.display = hasAny ? 'block' : 'none';

        const count = event.detail.count || 0;
        publishBtn.textContent = count > 0 ? `Publish Changes (${count})` : 'Publish Changes';
    };

    document.addEventListener('pendingChanges:updated', handlePendingChanges);
    eventHandlers.add({element: document, type: 'pendingChanges:updated', handler: handlePendingChanges});

    publishBtn.style.display = (hasPendingChanges() || hasBlockChanges()) ? 'block' : 'none';
}

export async function publishChanges() {
    if (!isAuthenticated()) {
        console.error('Authentication required to publish changes');
        showErrorNotification('Authentication required to publish changes');
        return;
    }

    if (!hasPendingChanges() && !hasBlockChanges()) {
        console.error('No changes to publish');
        return;
    }

    const publishBtnElement = document.getElementById(config.editor.selectors.publishButton);
    if (publishBtnElement) {
        publishBtnElement.textContent = 'Publishing...';
        publishBtnElement.disabled = true;
    }

    if (hasBlockChanges()) {
        await publishBlockChanges({ silent: true });
    }

    const changes = getPendingChanges();
    const promises = [];

    // Публикуем текстовые изменения
    for (const tagId in changes.text) {
        const publishFunction = window.publishTextChange || originalPublishTextChange;
        promises.push(publishFunction(tagId, changes.text[tagId]));
    }

    // ИСПРАВЛЕНИЕ: Теперь публикуем картинки и документы через их publishXXXChange функции
    // которые внутри сами вызовут saveXXXChange для загрузки на сервер
    for (const tagId in changes.image) {
        promises.push(publishImageChange(tagId, changes.image[tagId]));
    }

    for (const tagId in changes.youtube) {
        promises.push(publishYoutubeChange(tagId, changes.youtube[tagId]));
    }

    for (const tagId in changes.document) {
        promises.push(publishDocumentChange(tagId, changes.document[tagId]));
    }

    try {
        const results = await Promise.all(promises);

        // Очищаем кеш для всех типов контента
        for (const tagId in changes.text) {
            clearContentCache(tagId);
        }
        for (const tagId in changes.image) {
            clearContentCache(tagId);
        }
        for (const tagId in changes.youtube) {
            clearContentCache(tagId);
        }
        for (const tagId in changes.document) {
            clearContentCache(tagId);
        }

        clearPendingChanges();

        if (publishBtnElement) {
            publishBtnElement.textContent = 'Publish Changes';
            publishBtnElement.disabled = false;
            publishBtnElement.style.display = 'none';
        }

        showSuccessNotification('Changes published successfully!');
    } catch (error) {
        console.error('Error publishing changes:', error);
        showErrorNotification('Error publishing changes');

        if (publishBtnElement) {
            publishBtnElement.textContent = 'Publish Changes';
            publishBtnElement.disabled = false;
        }
    }
}